import InboomaBaseModel from './InboomaBaseModel';

export default InboomaBaseModel.extend({

    urlRoot : '/pricediscounts',
  /*  _timeFilter : [
        'from',
        'to',
    ],*/

    _save: function (key, val, options) {
        //this.beforeSave(key, val, options);
        console.log('save discounts model hook', key, val, options);
        return Backbone.Model.prototype.save.call(this, key, val, options);
    },

    /*validate: function(attr, options) {

        let begin, end;

        console.log('attr', attr.from, attr.to);

        if (_.isNull(attr.from) || attr.to == '') {
            return 'reservation_error_missing_begin';
        }

        if (_.isNull(attr.to) || attr.to == '') {
            return 'reservation_error_missing_end';
        }

        if (moment(attr.from).isValid() && moment(attr.to).isValid()) {
            // ISO 1806
            begin = moment(attr.from);
            end = moment(attr.to);
        } else if (moment(attr.from, 'D. MMMM YYYY').isValid() && moment(attr.to, 'D. MMMM YYYY').isValid()) {
            // D. MMMM YYYY
            begin = moment(attr.from, 'D. MMMM YYYY');
            end = moment(attr.to, 'D. MMMM YYYY');
        } else if (moment(attr.from, 'D. MMMM YYYY HH:mm').isValid() && moment(attr.to, 'D. MMMM YYYY HH:mm').isValid()) {
            // D. MMMM YYYY HH:mm
            begin = moment(attr.from, 'D. MMMM YYYY HH:mm');
            end = moment(attr.to, 'D. MMMM YYYY HH:mm');
        } else {
            return 'invalid_time_format';
        }

        console.log('attr', attr);

        if (begin.format('X') > end.format('X') || (false && attr.resourcetype_id != 4 && begin.format('X') == end.format('X'))) {
            return 'reservation_error_start_bigger_than_end';
        }

    },*/
    defaults : {
        "id" : "",
        "user_id" : null,
        "client_id" : null,
        "pricetariff_id" : null,
        "discount_type" : "client",
        "discount_percent" : null,
        "discount_amount": null,
        "count_units": null,
        "booking_type": "reservation",
        "discount_nbr": null,
        "combineable": false,
        "active": true,
        "valid_from": null,
        "valid_to": null,
        "created" : null,
        "modified" : null,
        "description" : ""
    },

    _rbac : {
        "admin" : {
            "read" : true,
            "write" : true,
            "edit" : true,
            "remove" : true
        },
        "user" : {
            "read" : true,
            "write" : false,
            "edit" : false,
            "remove" : false
        },
        "manager" : {
            "read" : true,
            "write" : false,
            "edit" : false,
            "remove" : true
        },
        "booking-manager" : {
            "read" : true,
            "write" : false,
            "edit" : false,
            "remove" : true
        }
    },

});
